import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

/*Bootstrap-icons */
import "bootstrap-icons/font/bootstrap-icons.css"

/* fontawesome-icons */
import "../node_modules/@fortawesome/fontawesome-free/css/all.css"

/*Bootstrap CSS */
import "../node_modules/bootstrap/dist/css/bootstrap.css"

/* Bootstrap JS */
import "../node_modules/bootstrap/dist/js/bootstrap.bundle"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
    
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
